import * as _ from 'lodash/fp'
import { accessoryProductFitsCarByID } from 'utils/accessoryProductFitsCarByID'

export function containsProductThatDontFitModelByID(cart, carID) {
  return _.some((cartElement) => !accessoryProductFitsCarByID(cartElement, carID), cart)
}
